import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { css } from '@bd/bdui-styles/emotion';
import { Link } from '@bd/bdcore-named-routes';
import withData from '@bd/bdcore-data';
import PhotoList from './PhotoList';

const styles = css`
  .GalleryPreview {
    padding: 0;
    position: relative;
    @media (min-width: 992px) {
      padding: 15px 0 150px 0;
    }
  }
  .PhotoGalleryList_mobile {
    width: 100%;
    display: block;
    min-height: 175px;
    @media (min-width: 992px) {
      display: none;
    }
  }
  .GalleryPreview_button {
    position: absolute;
    bottom: 125px;
    right: 0;
    left: 0;
    top: 0;
    bottom: 0;
    width: 310px;
    height: 47px;
    margin: auto;
    z-index: 1;
    @media (min-width: 992px) {
      top: auto;
      bottom: 125px;
    }
  }
`;

function PhotoGalleryList({ page }) {
  return (
    <div className={styles}>
      <div className="GalleryPreview">
        <img src={_.sample(page.featured_photos).contentUrl} className="PhotoGalleryList_mobile" alt="Gallery" />
        <PhotoList
          photos={_.sampleSize(page.featured_photos, 4).map((g, index) => ({
            image: g,
            title: index.toString(),
            route: 'photo-gallery',
          }))}
        />
        <Link className="btn GalleryPreview_button" name="photo-gallery">View Our Photo Gallery</Link>
      </div>
    </div>
  );
}

PhotoGalleryList.propTypes = {
  page: PropTypes.object.isRequired,
};

export default withData(
  {
    page: 'photo_gallery',
  },
)(PhotoGalleryList);



// WEBPACK FOOTER //
// ./src/pages/IndexPage/PhotoGalleryList.js